export default __webpack_public_path__ + "static/media/partnership-image.4272eeed.png";